import React from "react";
import styled from "styled-components";

const Prestations = () => {
  return (
    <PrestationsWrapper>
      <h1>Prestations</h1>
      <div className="tattoo">
        <div>
          <h2>Tatouage</h2>
          <p>Tatouage : sur devis</p>
        </div>
        <div>
          <h2>Soins</h2>
          <ListContainer>
            <h3>Pour le visage</h3>
            <li>
              Peeling microneedling<span className="price">150€</span>
            </li>
            <li>
              Pack 4 séances<span className="price">530€</span>
            </li>
            <li>
              Microneedling<span className="price">80€</span>
            </li>
            <li className="white">
              Peeling<span className="price">70€</span>
            </li>
          </ListContainer>
        </div>
      </div>
      <div className="maquillage">
        <h2>Maquillage semi-permanent</h2>
        <ul className="makeUp">
          <li>
            <h3>Les sourcils</h3>
            <ListContainer>
              <li>
                Effet « poudré » <span className="price">240€</span>
              </li>
              <li>
                Effet « sophistiqué »<span className="price">260€</span>
              </li>
              <li>
                Effet « poil à poil<span className="price">250€</span>
              </li>
              <li>
                Correction pigmentation<span className="price">230€</span>
              </li>
              <li>
                Queues de sourcils<span className="price">160€</span>
              </li>
              <li>
                Tête de sourcils<span className="price">160€</span>
              </li>
              <li>Prix valable pour 2 séances*</li>
            </ListContainer>
          </li>
          <li>
            <h3>Les yeux</h3>
            <ListContainer>
              <li>
                Le trait du haut<span className="price">160/190€</span>
              </li>
              <li>
                Le trait du bas<span className="price">130/190€</span>
              </li>
              <li>
                Powder liner<span className="price">180€</span>
              </li>
              <li>
                Le haut & le bas<span className="price">250/290€</span>
              </li>
              <li>Prix valable pour 2 séances*</li>
            </ListContainer>
          </li>
          <li>
            <h3>Les lèvres</h3>
            <ListContainer>
              <li>
                Contour des lèvres<span className="price">250€</span>
              </li>
              <li>
                « Oh my lips »<span className="price">290€</span>
              </li>
              <li>
                Effet rouge à lèvre<span className="price">300€</span>
              </li>
              <li>
                Sunny lips repulpe<span className="price">290€</span>
              </li>
              <li>
                Mise en lumière<span className="price">150€</span>
              </li>
              <li>Prix valable pour 2 séances*</li>
            </ListContainer>
          </li>
          <li>
            <h3>Petit plus</h3>
            <ListContainer>
              <li>
                Taches de rousseur (un peu)<span className="price">80€</span>
              </li>
              <li>
                Taches de rousseur (beaucoup)<span className="price">130€</span>
              </li>
              <li className="white">
                Un grain de beauté<span className="price">60€</span>
              </li>
            </ListContainer>
          </li>
        </ul>
      </div>
      <p className="yellow">* Séance - retouche</p>
    </PrestationsWrapper>
  );
};

export default Prestations;

const PrestationsWrapper = styled.div`
  width: 100%;
  height: fit-content;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.6rem;
  margin-bottom: 10vh;
  .yellow {
    color: #8f601a;
  }

  h1 {
    margin-bottom: 10vh;
  }
  ul,
  p {
    list-style: none;
    margin-bottom: 5vh;
  }
  p,
  li {
    font-size: 80%;
    font-weight: 100;
    letter-spacing: 0.1rem;
  }
  h2 {
    padding-bottom: 1vh;
    margin-bottom: 2vh;
    text-align: center;
  }
  h3 {
    padding-bottom: 1vh;
    margin-bottom: 2vh;
  }
  h2,
  h3 {
    color: #8f601a;
    text-transform: uppercase;
    font-weight: 400;
    border-bottom: 2px solid #8f601a;
  }
  .tattoo {
    display: grid;
    grid-template-columns: 1fr;
  }
  .maquillage {
    h2 {
      width: 70vw;
    }
  }
  .makeUp {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 5vh 5vw;
    grid-template-rows: 1fr 1fr;
    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`;

const ListContainer = styled.ul`
  min-width: 30vw;
  @media (max-width: 768px) {
    min-width: 70vw;
  }
  :last-child {
    color: #8f601a;
  }
  .white {
    color: white;
  }
  li {
    display: flex;
    justify-content: space-between;
    .price {
      margin-left: auto;
      color: white;
    }
  }
`;
